// Jquery function which adjusts for header when using HTML anchors
(function($, window) {
	var adjustAnchor = function() {

		var $anchor = $(':target'),
			fixedElementHeight = 200;

		if ($anchor.length > 0) {

			$('html, body')
			.stop()
			.animate({
				scrollTop: $anchor.offset().top - fixedElementHeight
			}, 200);

		}
	};

	$(window).on('hashchange load', function() {
		adjustAnchor();
	});

})(jQuery, window);

// Table of contents script
jQuery(document).ready(function ($) {
	let contents = $('.table-of-contents');

	if ( contents.length > 0 ) {

		let link = window.location.protocol + '//' + window.location.hostname + window.location.pathname;
		if ( contents.attr('id') ) {
			link = link + '#' + contents.attr('id');
		} else {
			contents.attr('id', 'id-1230912309');
			link = link + '#id-1230912309';
		}

		let html = '<a class="back-to-top hidden" href="' + link + '"></a>';

		$('body').append(html);

		$(document).on('scroll', function () {
			let scrollY = document.documentElement.style.getPropertyValue('--scroll-y');
			scrollY = parseInt(scrollY.slice(0, -2));
			let offset = Math.floor(contents.offset().top + contents.height());

			if ( scrollY > offset ) {
				$('.back-to-top').removeClass('hidden');
			} else {
				$('.back-to-top').addClass('hidden');
			}
		});
	}
});